/* i6 Tuning article pages. File: assets/i6-article.js
   - builds a split hero (dark text panel + photo) from whatever the page already has
   - adds an "In this guide" contents box (from the H2 headings), the reading time and a closing call to action
   If anything it needs is missing, it leaves the page as it is.                                              */
(function () {
  function words(el) { return (el.textContent || '').trim().split(/\s+/).filter(Boolean).length; }

  function hasVisible(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) return true;
      if (n.nodeType === 1) {
        if (n.style && n.style.display === 'none') continue;
        if (/^(IMG|IFRAME|VIDEO|BUTTON|SHARE-BUTTON|SVG|PICTURE)$/i.test(n.tagName)) return true;
        if (hasVisible(n)) return true;
      }
    }
    return false;
  }

  function prune(el, root) {
    while (el && el !== root && el.parentElement) {
      var p = el.parentElement;
      if (!hasVisible(el)) el.style.display = 'none';
      el = p;
    }
  }

  function buildHero(art, content, mins) {
    var h1 = art.querySelector('h1');
    if (!h1 || art.querySelector('.i6a-hero')) return false;
    var data = document.body.dataset || {};

    // the photo: the featured image if there is one, otherwise the first picture inside the text
    var img = art.querySelector('.article-template__hero-container img, .article-template__hero-small img, .article-template__hero-medium img, .article-template__hero-large img');
    var heroBlock = img ? (img.closest('[class*="article-template__hero"]') || img.parentElement) : null;
    var fromContent = false;
    if (!img && content) { img = content.querySelector('img'); fromContent = !!img; }

    // the date, and the share button
    var timeEl = art.querySelector('time');
    var dateText = timeEl ? timeEl.textContent.trim() : '';
    var dateWrap = timeEl ? (timeEl.closest('span,div,p') || timeEl) : null;
    var share = art.querySelector('share-button') || art.querySelector('.share-button') || art.querySelector('.article-template__social-sharing');

    var oldParents = [h1.parentElement];
    if (dateWrap) oldParents.push(dateWrap.parentElement);
    if (share) oldParents.push(share.parentElement);

    var hero = document.createElement('section');
    hero.className = 'i6a-hero' + (img ? '' : ' i6a-hero--text');
    var text = document.createElement('div');
    text.className = 'i6a-hero__text';

    if (data.i6Blog) {
      var crumbs = document.createElement('p');
      crumbs.className = 'i6a-crumbs';
      var home = document.createElement('a'); home.href = '/'; home.textContent = 'Home';
      var blogA = document.createElement('a'); blogA.href = data.i6BlogUrl || '/'; blogA.textContent = data.i6Blog;
      crumbs.appendChild(home);
      crumbs.appendChild(document.createTextNode(' / '));
      crumbs.appendChild(blogA);
      crumbs.appendChild(document.createTextNode(' / ' + h1.textContent.trim()));
      text.appendChild(crumbs);
      var label = document.createElement('span');
      label.className = 'i6a-label';
      label.textContent = data.i6Blog;
      text.appendChild(label);
    }
    text.appendChild(h1);
    if (data.i6Excerpt) {
      var intro = document.createElement('p');
      intro.className = 'i6a-intro';
      intro.textContent = data.i6Excerpt;
      text.appendChild(intro);
    }
    var meta = document.createElement('p');
    meta.className = 'i6a-meta';
    meta.textContent = (dateText ? dateText + ' \u00b7 ' : '') + mins + ' min read';
    text.appendChild(meta);
    if (share) text.appendChild(share);
    hero.appendChild(text);

    if (img) {
      var media = document.createElement('div');
      media.className = 'i6a-hero__media';
      var im = document.createElement('img');
      im.src = img.getAttribute('src') || img.currentSrc || '';
      if (img.getAttribute('srcset')) im.setAttribute('srcset', img.getAttribute('srcset'));
      im.setAttribute('sizes', '(max-width: 899px) 100vw, 50vw');
      im.alt = img.getAttribute('alt') || '';
      im.setAttribute('fetchpriority', 'high');
      media.appendChild(im);
      hero.appendChild(media);
      if (fromContent) {
        var holder = img.closest('figure,p');
        if (holder && holder !== content && !holder.textContent.trim()) holder.parentNode.removeChild(holder); else img.parentNode.removeChild(img);
      } else if (heroBlock) {
        heroBlock.style.display = 'none';
      }
    }
    if (dateWrap) dateWrap.style.display = 'none';

    art.insertBefore(hero, art.firstElementChild);
    oldParents.forEach(function (p) { prune(p, art); });
    return true;
  }

  function init() {
    var content = document.querySelector('.article-template__content');
    if (!content || content.getAttribute('data-i6a')) return;
    content.setAttribute('data-i6a', '1');
    var art = content.closest('article') || content.closest('.article-template') || document.querySelector('article');
    var mins = Math.max(1, Math.round(words(content) / 200));

    var built = false;
    try { built = art ? buildHero(art, content, mins) : false; } catch (e) { built = false; }
    if (!built) {
      var meta = document.querySelector('.article-template__header .caption-with-letter-spacing, .article-template__header .circle-divider');
      if (meta) { var sp = document.createElement('span'); sp.textContent = ' \u00b7 ' + mins + ' min read'; meta.appendChild(sp); }
    }

    // contents box from the H2 headings
    var heads = Array.prototype.slice.call(content.querySelectorAll('h2')).filter(function (h) { return h.textContent.trim().length > 0; });
    if (heads.length >= 3) {
      var used = {};
      var box = document.createElement('nav');
      box.className = 'i6a-toc';
      box.setAttribute('aria-label', 'In this guide');
      var inner = document.createElement('div');
      inner.className = 'i6a-toc__box';
      var title = document.createElement('p');
      title.className = 'i6a-toc__title';
      title.textContent = 'In this guide';
      var ol = document.createElement('ol');
      heads.forEach(function (h, i) {
        var base = (h.id || h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section-' + (i + 1));
        var id = base, n = 2;
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) { id = base + '-' + n++; }
        used[id] = true;
        h.id = id;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
      });
      inner.appendChild(title);
      inner.appendChild(ol);
      box.appendChild(inner);
      content.parentNode.insertBefore(box, content);
    }

    // closing call to action
    var cta = document.createElement('aside');
    cta.className = 'i6a-cta';
    cta.innerHTML = '<div class="i6a-cta__box"><p class="i6a-cta__title">Not sure what fits your car?</p>' +
      '<p class="i6a-cta__text">Send us your VIN and we\u2019ll check fitment before you order.</p>' +
      '<div class="i6a-cta__btns"><a class="i6a-cta__btn i6a-cta__btn--solid" href="/pages/shop-by-car">Shop by car</a>' +
      '<a class="i6a-cta__btn i6a-cta__btn--line" href="/pages/contact-us">Get in touch</a></div></div>';
    content.parentNode.insertBefore(cta, content.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();